import { QBox, QFlex } from '@qualio/ui-components';
import React, { PropsWithChildren, useContext } from 'react';
import { DocumentOverviewContext, ZoomContext } from '../Context';
import styles from './QMultiRootEditor.module.css';

type QMultiRootEditorLayoutProps = {
  contentId: string;
};

export const QMultiRootEditorLayout: React.FC<
  PropsWithChildren<QMultiRootEditorLayoutProps>
> = ({ children, contentId }) => {
  const zoomContext = useContext(ZoomContext);
  const scale = zoomContext?.scale ?? 1;

  const { qualioDocument } = useContext(DocumentOverviewContext);
  const showLandscapeMode = qualioDocument.orientation === 'landscape';

  return (
    <QFlex position="relative" height="fit-content">
      <QBox
        style={{
          zoom: `${scale}`,
        }}
      >
        <QBox
          my={4}
          ml={0}
          border="1px"
          borderColor="gray.200"
          boxShadow="md"
          id={contentId}
          data-cy="documentEditorContent"
          className={`${
            styles['document-section-content']
          } multiroot document ${showLandscapeMode ? 'landscape' : ''}`}
        >
          {children}
        </QBox>
      </QBox>
    </QFlex>
  );
};
